(function () {
  'use strict';

  // Only the first-column cells get `color-scheme-2` — NOT the outer
  // `.frengee-product-specifications` block. The theme's global rule
  // (snippets/settings.liquid) paints `color` + `background-color` on
  // *any* element carrying a `.color-scheme-N` class, not just <body>.
  // Adding it higher up repaints every inherited text node inside,
  // including the tab labels, which don't set their own color.
  var FIRST_COL_SELECTOR = [
    '.frengee-unified-table th:first-child',
    '.frengee-unified-table td:first-child',
    '.unified-table-mobile th:first-child',
    '.unified-table-mobile td:first-child',
    '.frengee-dropdown-content td:first-child',
    '.frengee-product-tabs table td:first-child',
    '.frengee-product-tabs table th:first-child',
    '.frengee-geometry-content table td:first-child',
    '.frengee-geometry-content table th:first-child',
  ].join(',');

  function processAll() {
    document.querySelectorAll('.frengee-product-specifications').forEach(function (block) {
      block.querySelectorAll(FIRST_COL_SELECTOR).forEach(function (cell) {
        if (!cell.classList.contains('color-scheme-2')) {
          cell.classList.add('color-scheme-2');
        }
      });
    });
  }

  var scheduled = false;
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(function () {
      scheduled = false;
      processAll();
    });
  }

  schedule();

  new MutationObserver(schedule).observe(document.body, {
    childList: true,
    subtree: true,
    characterData: true,
  });
})();
